// AWS: USER AUTHENTICATION
export const AWS_USER_REQUEST = 'auth::user_request'
export const AWS_USER_REQUEST_SUCCESS = 'auth::user_request_success'
export const AWS_USER_REQUEST_FAILURE = 'auth::user_request_failure'
export const AWS_USER_REQUEST_CLEAR = 'auth::user_request_clear'
export const AWS_USER_REQUEST_REFRESH_FAILURE = 'auth::user_request_refresh_failure'
export const AWS_USER_REQUEST_REFRESH_SUCCESS = 'auth::user_request_refresh_success'
export const AWS_USER_UPDATE = 'auth::user_update'
export const AWS_USER_UPDATE_SUCCESS = 'auth::user_update_success'
export const AWS_USER_UPDATE_FAILURE = 'auth::user_update_failure'
export const AWS_USER_REQUEST_CACHE = 'auth::user_request_cache'

// AWS: TENANTS (USERS TENANTS TENANT)
export const AWS_UTT_REQUEST = 'auth::utt_request'
export const AWS_UTT_REQUEST_SUCCESS = 'auth::utt_request_success'
export const AWS_UTT_REQUEST_FAILURE = 'auth::utt_request_failure'
export const AWS_UTT_CACHE = 'auth::utt_cache'
export const AWS_UTT_SET_CURRENT = 'auth::utt_set_current'

// AWS: TENANTS (USERS TENANTS USER)
export const AWS_UTU_REQUEST = 'auth::utu_request'
export const AWS_UTU_REQUEST_SUCCESS = 'auth::utu_request_success'
export const AWS_UTU_REQUEST_FAILURE = 'auth::utu_request_failure'
export const AWS_UTU_CACHE = 'auth::utu_cache'

// FARMDECK: API SENSOR TYPES
export const FD_SENTYP_REQUEST = 'fdapi::sensortype_request'
export const FD_SENTYP_REQUEST_SUCCESS = 'fdapi::sensortype_request_success'
export const FD_SENTYP_FAILURE = 'fdapi::sensortype_request_failure'
export const FD_SENTYP_CACHE = 'fdapi::sensortype_request_cache'

// FARMDECK: API SENSORS
export const FD_SEN_REQUEST = 'fdapi::sensor_request'
export const FD_SEN_REQUEST_SUCCESS = 'fdapi::sensor_request_success'
export const FD_SEN_FAILURE = 'fdapi::sensor_request_failure'
export const FD_SEN_CACHE = 'fdapi::sensor_cache'

// FARMDECK: API ASSETS
export const FD_ASS_REQUEST = 'fdapi::asset_request'
export const FD_ASS_REQUEST_SUCCESS = 'fdapi::asset_request_success'
export const FD_ASS_REQUEST_FAILURE = 'fdapi::asset_request_failure'
export const FD_ASS_CACHE = 'fdapi::asset_cache'
export const FD_ASS_FAKE = 'fdapi::asset_fake'

// FARMDECK: API ASSET TYPES
export const FD_ASSTYP_REQUEST = 'fdapi::asset_type_request'
export const FD_ASSTYP_REQUEST_SUCCESS = 'fdapi::asset_type_request_success'
export const FD_ASSTYP_REQUEST_FAILURE = 'fdapi::asset_type_request_failure'
export const FD_ASSTYP_CACHE = 'fdapi::asset_type_cache'

// FARMDECK: API PADDOCKS
export const FD_PAD_REQUEST = 'fdapi::paddock_request'
export const FD_PAD_REQUEST_SUCCESS = 'fdapi::paddock_request_success'
export const FD_PAD_REQUEST_FAILURE = 'fdapi::paddock_request_failure'
export const FD_PAD_CACHE = 'fdapi::paddock_cache'

// FARMDECK: API TASKMANAGER
export const FD_TSK_PROJS_REQUEST = 'fdapi::taskmanager_projects_request'
export const FD_TSK_PROJS_REQUEST_SUCCESS = 'fdapi::taskmanager_projects_request_success'
export const FD_TSK_PROJS_REQUEST_FAILURE = 'fdapi::taskmanager_projects_request_failure'
export const FD_TSK_PROJS_CACHE = 'fdapi::taskmanager_projects_request_cache'
export const FD_TSK_PROJ_REQUEST = 'fdapi::taskmanager_project_request'
export const FD_TSK_PROJ_REQUEST_SUCCESS = 'fdapi::taskmanager_project_request_success'
export const FD_TSK_PROJ_REQUEST_FAILURE = 'fdapi::taskmanager_project_request_failure'
export const FD_TSK_PROJ_CACHE = 'fdapi::taskmanager_project_request_cache'

// FARMDECK: API LIVESTOCK/MOBS/ENUMITEMS
export const FD_MOBS_REQUEST = 'fdapi::mobs_request'
export const FD_MOBS_REQUEST_SUCCESS = 'fdapi::mobs_request_success'
export const FD_MOBS_REQUEST_FAILURE = 'fdapi::mobs_request_failure'
export const FD_MOBS_CACHE = 'fdapi::mobs_cache'
export const FD_EI_REQUEST = 'fdapi::en_request'
export const FD_EI_REQUEST_SUCCESS = 'fdapi::en_request_success'
export const FD_EI_REQUEST_FAILURE = 'fdapi::en_request_failure'
export const FD_EI_CACHE = 'fdapi::en_cache'

// FARMDECK: PAYLOAD
export const FD_PAYLD_LL_REQUEST = 'fdapi::payload_ll_request'
export const FD_PAYLD_LL_REQUEST_SUCCESS = 'fdapi::payload_ll_request_success'
export const FD_PAYLD_LL_REQUEST_FAILURE = 'fdapi::payload_ll_request_failure'
export const FD_PAYLD_SEN_REQUEST = 'fdapi::payload_sen_request'
export const FD_PAYLD_SEN_REQUEST_SUCCESS = 'fdapi::payload_sen_request_success'
export const FD_PAYLD_SEN_REQUEST_FAILURE = 'fdapi::payload_sen_request_failure'

// AUTHORIZE
export const AUTH_USER = 'auth::user_token'

// WEATHER
export const WEATHER_REQUEST = 'weather::current_request'
export const WEATHER_REQUEST_SUCCESS = 'weather::current_request_success'
export const WEATHER_REQUEST_FAILURE = 'weather::current_request_failure'
export const WEATHER_CACHE = 'weather::current_request_cache'

// FARMDECK: API USERS
export const FD_USERS_REQUEST = 'fdapi::users_request'
export const FD_USERS_REQUEST_SUCCESS = 'fdapi::users_request_success'
export const FD_USERS_REQUEST_FAILURE = 'fdapi::users_request_failure'
export const FD_USERS_CACHE = 'fdapi::users_cache'

// FARMDECK: ME/FARMS
export const FD_ME_REQUEST = 'fdapi::me_request'
export const FD_ME_REQUEST_SUCCESS = 'fdapi::me_request_success'
export const FD_ME_REQUEST_FAILURE = 'fdapi::me_request_failure'
export const FD_ME_CACHE = 'fdapi::me_cache'
export const FD_FARMS_REQUEST = 'fdapi::farms_request'
export const FD_FARMS_REQUEST_SUCCESS = 'fdapi::farms_request_success'
export const FD_FARMS_REQUEST_FAILURE = 'fdapi::farms_request_failure'
export const FD_FARMS_CACHE = 'fdapi::farms_cache'
export const FD_FARMID_REQUEST = 'fdapi::farmid_request'
export const FD_FARMID_SET = 'fdapi::farmid_set'
export const FD_US_REQUEST = 'fdapi::us_request'
export const FD_US_REQUEST_SUCCESS = 'fdapi::us_request_success'
export const FD_US_REQUEST_FAILURE = 'fdapi::us_request_failure'
export const FD_US_CACHE = 'fdapi::us_cache'

// FARMDECK: API SPRAYING CONDITIONS
export const FD_SPRAY_RECORDS_REQUEST = 'fdapi::spray_records_type_request'
export const FD_SPRAY_RECORDS_REQUEST_SUCCESS = 'fdapi::spray_records_type_request_success'
export const FD_SPRAY_RECORDS_UPDATE = 'fdapi::spray_records_type_update'
export const FD_SPRAY_RECORDS_REQUEST_FAILURE = 'fdapi::spray_records_type_request_failure'
export const FD_SPRAY_RECORDS_CACHE = 'fdapi::spray_records_type_cache'
// FARMDECK: API AGRICHEMICAL EVENTS
export const FD_AGRICHEMICAL_RECORDS_REQUEST = 'fdapi::agrichemical_records_type_request'
export const FD_AGRICHEMICAL_RECORDS_REQUEST_SUCCESS = 'fdapi::agrichemical_records_type_request_success'
export const FD_AGRICHEMICAL_RECORDS_UPDATE = 'fdapi::agrichemical_records_type_update'
export const FD_AGRICHEMICAL_RECORDS_REQUEST_FAILURE = 'fdapi::agrichemical_records_type_request_failure'
export const FD_AGRICHEMICAL_RECORDS_CACHE = 'fdapi::agrichemical_records_type_cache'
// FARMDECK: API PESTCHEMICAL EVENTS
export const FD_PESTCHEMICAL_RECORDS_REQUEST = 'fdapi::pestchemical_records_type_request'
export const FD_PESTCHEMICAL_RECORDS_REQUEST_SUCCESS = 'fdapi::pestchemical_records_type_request_success'
export const FD_PESTCHEMICAL_RECORDS_UPDATE = 'fdapi::pestchemical_records_type_update'
export const FD_PESTCHEMICAL_RECORDS_REQUEST_FAILURE = 'fdapi::pestchemical_records_type_request_failure'
export const FD_PESTCHEMICAL_RECORDS_CACHE = 'fdapi::pestchemical_records_type_cache'
// FARMDECK: API VETCHEMICAL EVENTS
export const FD_VETCHEMICAL_RECORDS_REQUEST = 'fdapi::vetchemical_records_type_request'
export const FD_VETCHEMICAL_RECORDS_REQUEST_SUCCESS = 'fdapi::vetchemical_records_type_request_success'
export const FD_VETCHEMICAL_RECORDS_UPDATE = 'fdapi::vetchemical_records_type_update'
export const FD_VETCHEMICAL_RECORDS_REQUEST_FAILURE = 'fdapi::vetchemical_records_type_request_failure'
export const FD_VETCHEMICAL_RECORDS_CACHE = 'fdapi::vetchemical_records_type_cache'
// FARMDECK: UI
export const FD_UI_TOGGLE_USERDROPDOWN = 'fdui::toggle_userdropdown'

//FIREBASE: NOTIFICATIONS
export const FD_NOTIFICATIONS_SET = 'fbapi::notifications_set'
export const FD_NOTIFICATIONS_SIGNIN = 'fbapi::signin_success'
export const FD_NOTIFICATIONS_SIGNIN_FAIL = 'fbapi::signin_failure'
//FIREBASE: DEVICE NOTIFICATIONS
export const FD_DEVNOTIFICATIONS_SET = 'fbapi::devnotifications_set'
// FIREBASE: AUTOMATIONS (entities + sensors)
export const FD_AUTOMATIONS_ENTITIES_SET = 'fbapi::automations_entities_set'
export const FD_AUTOMATIONS_SENSORS_SET = 'fbapi::automations_sensors_set'

// FARMDECK: PLANNING EVENTS
export const PE_REQUEST = 'fdapi::pe_request'
export const PE_REQUEST_SUCCESS = 'fdapi::pe_request_success'
export const PE_REQUEST_FAILURE = 'fdapi::pe_request_failure'
export const PE_CACHE = 'fdapi::pe_cache'

// FEEDS
export const FD_FEEDS_REQUEST = 'fdapi::feeds_request'
export const FD_FEEDS_REQUEST_SUCCESS = 'fdapi::feeds_request_success'
export const FD_FEEDS_REQUEST_FAILURE = 'fdapi::feeds_request_failure'
export const FD_FEEDS_REQUEST_CACHE = 'fdapi::feeds_request_cache'

// PAYMENTS
export const FD_PAYMENTS_CUSTOMER_REQUEST = 'fdapi::payments_customer_request'
export const FD_PAYMENTS_CUSTOMER_REQUEST_SUCCESS = 'fdapi::payments_customer_request_success'
export const FD_PAYMENTS_CUSTOMER_REQUEST_FAILURE = 'fdapi::payments_customer_request_failure'
export const FD_PAYMENTS_CUSTOMER_REQUEST_CACHE = 'fdapi::payments_customer_request_cache'

// MISC
export const STORE_INIT = 'fdapi::store_init'
